import React from "react";
import { useNavigate, useParams } from "react-router-dom";


function OptionsPage({ page }) {
    const { link } = useParams();
    const navigate = useNavigate();

    const handleTextEditPage = () => {
        navigate(`/admin/text/${link}`);
    };
    const handleImgEditPage = () => {
        navigate(`/admin/img/${link}`);
    };
    const handleUrlEditPage = () => {
        navigate(`/admin/url/${link}`);
    };

    return (
        <div className="container d-flex justify-content-center align-items-center vh-100">
        <div className="row text-center">
            <h1 className="mb-4">Wähle eine Option</h1>
            <div className="col-md-4 mb-3">
            <div className="card shadow">
                <div className="card-body">
                <h5 className="card-title">Texteditor</h5>
                <p className="card-text">
                    Bearbeite Texte direkt in unserem intuitiven Editor.
                </p>
                <button className="btn btn-primary" onClick={handleTextEditPage}>
                    Öffnen
                </button>
                </div>
            </div>
            </div>
            <div className="col-md-4 mb-3">
            <div className="card shadow">
                <div className="card-body">
                <h5 className="card-title">Bild hochladen</h5>
                <p className="card-text">
                    Lade ein Bild hoch
                </p>
                <button className="btn btn-primary" onClick={handleImgEditPage}>
                    Öffnen
                </button>
                </div>
            </div>
            </div>
            <div className="col-md-4 mb-3">
            <div className="card shadow">
                <div className="card-body">
                <h5 className="card-title">Weiterleitung</h5>
                <p className="card-text">
                    Richte eine Weiterleitung zu einer externen Seite ein.
                </p>
                <button className="btn btn-primary" onClick={handleUrlEditPage}>
                    Öffnen
                </button>
                </div>
            </div>
            </div>
        </div>
        </div>
    );
}

export default OptionsPage;
